export default __webpack_public_path__ + "static/media/new_logo.3a6edc07.png";